import {
  // Box,
  ChevronUp,
  // Edit,
  // Eye,
  // Filter,
  // GitMerge,
  // PlusCircle,
  RotateCcw,
  // Sliders,
  // StopCircle,
  // Trash2,
} from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState } from "react"; // ,{ useEffect, useState }
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
//   import Select from "react-select";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import Brand from "../../../core/modals/inventory/brand";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
// import { all_routes } from "../../../Router/all_routes";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
// import Table from "../../../core/pagination/datatable";
import { setToogleHeader } from "../../../core/redux/action";
import CommonMaterialReactTable from "../../MaterialReactTable/CommonMaterialReactTable";
import axios from "axios";
import { backendUrl } from "../../../config";
import DatePickup from "../../components/DatePickup/DatePickup";
import moment from "moment";
//   import { Download } from "react-feather";

const SalesDailyReport = () => {
  //   const dataSource = useSelector((state) => state.product_list);
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const [dataList, setDataList] = useState([]);
  const Yesterday = moment().subtract(1, "days").toDate();
  const [filterDate, setFilterDate] = useState(Yesterday);

  console.log(filterDate, "filterDate");
  const columns = [
    { accessorKey: "Name", header: "Name" },
    { accessorKey: "Product_Code", header: "Product Code" },
    { accessorKey: "Category_Code", header: "Category Code" },
    { accessorKey: "Description", header: "Description" },
    { accessorKey: "Scan_Identifier", header: "Scan Identifier" },
    { accessorKey: "Requires_Customization", header: "Requires Customization" },
  ];

  console.log(dataList, "productlist p");
  console.log(columns, "productlist c");

  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = () => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        MySwal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          className: "btn btn-success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      } else {
        MySwal.close();
      }
    });
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderPrinterTooltip = (props) => (
    <Tooltip id="printer-tooltip" {...props}>
      Printer
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const reportsDataListApi = async (filterDate) => {
    const date = moment(filterDate).format("YYYY-MM-DD");
    await axios
      .get(`${backendUrl}/reports/salesdailyreport?date=${date}`)
      .then((res) => {
        console.log(res, "data");
        setDataList(res.data.ResponseData);
        //   dispatch({ type: "PRODUCT_LIST", payload: data });
      });
  };

  useEffect(() => {
    reportsDataListApi(filterDate);
  }, []);

  const handleDateChange = (selectedDate) => {
    console.log(selectedDate, "selectedDate");
    if (selectedDate) {
      setFilterDate(selectedDate);
    }
  };

  const handleSubmit = () => {
    reportsDataListApi(filterDate);
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Sales Daily Report</h4>
              <h6>Manage Your Sales Daily Report</h6>
            </div>
            <div className="page-btn import">
              <DatePickup
                filterDate={filterDate}
                handleDateChange={handleDateChange}
              />
            </div>
            <div className="page-btn" onClick={handleSubmit}>
              <Link to="#" className="btn btn-added">
                Submit
              </Link>
            </div>
          </div>

          <ul className="table-top-head">
            <li>
              <OverlayTrigger placement="top" overlay={renderTooltip}>
                <Link>
                  <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <ImageWithBasePath
                    src="assets/img/icons/excel.svg"
                    alt="img"
                    onClick={() => {
                      showConfirmationAlert();
                    }}
                  />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderPrinterTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <i data-feather="printer" className="feather-printer" />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger
                placement="top"
                overlay={renderRefreshTooltip}
                onClick={reportsDataListApi}
              >
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
        </div>
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-responsive">
              <CommonMaterialReactTable columns={columns} data={dataList} />
            </div>
          </div>
        </div>
        <Brand />
      </div>
    </div>
  );
};

export default SalesDailyReport;
